import ColorsZone from 'components/Catalog/ProductGrid/CompareModal/Zones/ColorsZone/ColorsZone';

export default ColorsZone;
